/*
  Campaign PDP helpers. Loaded in <head> by snippets/campaign-head.liquid.
  Videos inside an element with data-end="<seconds>" loop back to 0 before that second
  (used to skip end title cards on the split and residents close-up videos).
*/
(function () {
  if (window.__cmpVideoEnd) return;
  window.__cmpVideoEnd = true;
  function limit(v) { var h = v.dataset.end ? v : v.closest('[data-end]'); var e = h ? parseFloat(h.dataset.end) : 0; return e > 0 ? e : 0; }
  function check(v) { var e = limit(v); if (e && v.currentTime >= e) { v.currentTime = 0; var p = v.play(); if (p) p.catch(function () {}); } }
  document.addEventListener('timeupdate', function (ev) { var v = ev.target; if (v && v.tagName === 'VIDEO') check(v); }, true);
  document.addEventListener('play', function (ev) {
    var v = ev.target;
    if (!v || v.tagName !== 'VIDEO' || v.__cmpEnd || !limit(v) || !v.requestVideoFrameCallback) return;
    v.__cmpEnd = true;
    var f = function () { check(v); v.requestVideoFrameCallback(f); };
    v.requestVideoFrameCallback(f);
  }, true);
})();
